<div *transloco="let l; prefix: 'mix'" class="floating-container" #floatingContainer>
    <div class="bg-second w-full">
        <div
            class="max-w-[1600px] mx-auto md:h-[65px] h-[50px] flex items-center px-2 sm:px-4 md:px-6 justify-between md:gap-8"
        >
            <div class="flex items-center md:gap-6 gap-2 flex-shrink-0">
                <a [routerLink]="['/']" class="flex-shrink-0">
                    @if (headerBranding.type === 'image') {
                        <img [alt]="headerBranding.alt" [class]="headerBranding.class" [src]="headerBranding.src" />
                    } @else {
                        <span [class]="headerBranding.class">{{ headerBranding.text }}</span>
                    }
                </a>
                <button
                    [routerLink]="['/']"
                    class="flex items-center justify-center w-[30px] h-[30px] sm:hidden border border-gray rounded-md text-white hover:bg-zinc-800 transition-colors"
                >
                    <i class="pi pi-home leading-none" style="font-size: 1.1rem"></i>
                </button>

            </div>

            <div class="sm:inline flex-1 max-w-full min-w-0 mx-3 md:mx-8 xl:mx-16 relative">
                <svg
                    class="absolute sm:right-4 right-2 top-1/2 transform -translate-y-1/2 sm:w-5 sm:h-5 w-4 h-4 text-gray-400 pointer-events-none z-10"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M21 21l-4.35-4.35M10 18a8 8 0 100-16 8 8 0 000 16z"
                    ></path>
                </svg>
                <vsf-product-search-bar class=""></vsf-product-search-bar>
            </div>

            <div class="flex items-center md:gap-2 flex-shrink-0 sm:mr-3 mr-1">
                <!-- <button class="flex items-center gap-1.5 text-white hover:text-gray-300 transition-colors sm:p-2 p-1">
                    <span class="text-sm sm:text-base font-medium">DE</span>
                    <svg class="w-4 h-4 hidden md:inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                    </svg>
                </button> -->

                <!-- Language Selector -->
                <p-select
                    class="drop-down-menu text-center"
                    test-id="language-selector"
                    (onChange)="changeLang($event.value)"
                    optionLabel="name"
                    optionValue="code"
                    [options]="[
                        { code: 'en', name: 'EN' },
                        { code: 'de', name: 'DE' }
                    ]"
                    [(ngModel)]="selectedLanguage"
                >
                    <!-- <ng-template #dropdownicon>
                        <i class="w-4 h-3 text-white bg-header-arrow-down bg-no-repeat bg-contain bg-center"></i>
                    </ng-template> -->
                </p-select>

                <!-- Account -->
                <a class="text-white hover:text-gray-300 transition-colors sm:p-2 p-1 cursor-pointer mobile-hide">
                    <vsf-account-link class=""></vsf-account-link>
                </a>

                <!-- Wishlist -->
                <a [routerLink]="['/account/wishlist']" class="relative text-white hover:text-gray-300 transition-colors sm:p-2 p-1 mobile-hide">
                    <svg class="sm:w-7 sm:h-7 w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                        ></path>
                    </svg>
                    @if ((wishlistItemCount$ | async); as count){
                    <span
                        [class.opacity-0]="count === 0"
                        class="absolute sm:-top-1 sm:-right-1 top-0 right-0 rounded-full sm:w-5 sm:h-5 w-4 h-4 flex items-center justify-center transition-all bg-[#ff4141]"
                    >
                        <span class="text-xs font-semibold">{{ count }}</span>
                    </span>
                    }
                </a>

                <!-- Cart -->
                <button (click)="openCartDrawer()" class="relative text-white hover:text-gray-300 transition-colors sm:p-2 p-1">
                    <svg class="sm:w-7 sm:h-7 w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 014 0z"
                        ></path>
                    </svg>
                    @if ((cartItemCount$ | async); as count){
                    <span
                        [class.opacity-0]="count === 0"
                        class="absolute sm:-top-1 sm:-right-1 top-0 right-0 bg-red rounded-full sm:w-5 sm:h-5 w-4 h-4 flex items-center justify-center text-white transition-all"
                    >
                        <span class="text-xs font-semibold">{{ count }}</span>
                    </span>
                    }
                </button>
            </div>
        </div>
    </div>
</div>
